/* eslint react/jsx-key: off */
import React, {useState} from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  DeleteWithConfirmButton,
  Toolbar,
  SaveButton,
  //ReferenceInput,
  SelectInput,
  ImageField,
  //TextField,
  //Tab,
  FileField,
  SingleFieldList,
  //ArrayInput,
  ChipField,
  //SimpleFormIterator,
  ArrayField,
  //Datagrid,
  required
} from 'react-admin';
// import RichTextInput from 'ra-input-rich-text';
import {withStyles} from '@material-ui/core';
import {styles} from './VendorCreate';
//import {HTTP_GET} from '../../common/HttpService';
// import {HTTP_GET} from '../../common/HttpService.js';
import SimpleChipField from './SimpleChipField';

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

const VendorEditToolbar = withStyles(toolbarStyles)(({...props}) => (
  <Toolbar {...props}>
    <SaveButton />
    {props.record.id && <DeleteWithConfirmButton />}
  </Toolbar>
));

const currentStatusList = [
  {id: 'request_pending', name: 'request_pending'},
  {id: 'disqualified', name: 'disqualified'},
  {id: 'qualified', name: 'qualified'}
];

const serviceStatusList = [
  {id: 'request_pending', name: 'Waiting for Approval / Requested'},
  {id: 'active', name: 'Active'},
  {id: 'rejected', name: 'Rejected'},
  {id: 'NA', name: 'Not Requested'}
];

const Title = ({record}) => {
  return <span>Edit: {record ? `${record.vendorName}` : ''} </span>;
};
const VendorEditContent = (props) => {
  const {record} = props;
  const isManpower = record && record.manpowerStatus && record.manpowerStatus !== 'NA';
  const isProject = record && record.projectStatus && record.projectStatus !== 'NA';
  const isRental = record && record.rentalStatus && record.rentalStatus !== 'NA';
  const isTraining = record && record.trainerStatus && record.trainerStatus !== 'NA';

  return (
    <TabbedForm toolbar={<VendorEditToolbar />} {...props}>
      <FormTab label="Vendor Details">
        <TextInput disabled source="id" />
        <TextInput source="vendorName" />
        <TextInput source="phone" />
        <TextInput source="email" />
        <TextInput source="serviceName" />
        <ArrayField source="profession">
          <SingleFieldList linkType={false}>
            <SimpleChipField />
          </SingleFieldList>
        </ArrayField>
        <TextInput disabled source="qualification" />
        <TextInput disabled source="type" />
        <TextInput disabled source="gender" />
        <TextInput disabled source="yearOfExperience" />
      </FormTab>
      <FormTab label="Status">
        <TextInput disabled source="workingStatus" />
        <TextInput disabled source="currentUserRole" />
        <TextInput disabled label="Profit Percentage (%)" source="profitPercentage" />
        <SelectInput label="Overall Vendor Status" source="currentStatus" choices={currentStatusList} />
        {isManpower && <SelectInput label="Manpower Status" source="manpowerStatus" choices={serviceStatusList} />}
        {isProject && <SelectInput label="Project Status" source="projectStatus" choices={serviceStatusList} />}
        {isRental && <SelectInput label="Rental Status" source="rentalStatus" choices={serviceStatusList} />}
        {isTraining && <SelectInput label="Training Status" source="trainerStatus" choices={serviceStatusList} />}
      </FormTab>
      {isManpower && (
        <FormTab label="Manpower status">
          <TextInput disabled source="vendorName" />
          <SelectInput source="manpowerStatus" choices={serviceStatusList} />
        </FormTab>
      )}
      {isRental && (
        <FormTab label="Rental status">
          <TextInput disabled source="vendorName" />
          <SelectInput source="rentalStatus" choices={serviceStatusList} />
        </FormTab>
      )}
      {isTraining && (
        <FormTab label="Training status">
          <TextInput disabled source="vendorName" />
          <SelectInput source="trainerStatus" choices={serviceStatusList} />
        </FormTab>
      )}
      {isProject && (
        <FormTab label="Project status">
          <TextInput disabled source="vendorName" />
          <SelectInput source="projectStatus" choices={serviceStatusList} />
        </FormTab>
      )}
      <FormTab label="Images">
        <ImageField source="passportImagePath" src="passportImagePath" label="passport image" />
        <ImageField source="liveImagePath" src="liveImagePath" label="live image" />
      </FormTab>
      <FormTab label="Documents">
        <FileField source="cvUploadPath" title="CV" label="" />
        <FileField source="certificateUploadPath" title="certificate" label="" />
      </FormTab>
      <FormTab label="Address">
        <TextInput disabled source="address" />
        <TextInput disabled source="localbody" />
        <TextInput disabled source="district" />
        <TextInput disabled source="state" />
        <TextInput disabled source="pincode" />
        <TextInput disabled source="phone" />
        <TextInput disabled source="email" />
      </FormTab>
    </TabbedForm>
  );
};

const VendorEdit = ({classes, ...props}) => (
  <Edit title={<Title />} {...props}>
    <VendorEditContent />
  </Edit>
);

VendorEdit.propTypes = {};

export default withStyles(styles)(VendorEdit);
